<template>
    <div class="page-news-detail">
        <div class="content">
            <div class="context">
                <div class="title">
                    {{detail.title}}
                </div>

                <div class="addtime">
                    {{detail.addtime}}
                </div>

                <div
                    class="html rich-text"
                    v-html="detail.content"
                ></div>

                <a
                    class="link"
                    v-if="detail.linkurl"
                    :href="detail.linkurl"
                    target="_blank"
                >原文链接</a>
            </div>
        </div>
    </div>
</template>

<script>
import {buildTdk} from '@config/tdk';
import appNode from '@js/app-node';

export default {
    head() {
        var tdk = (buildTdk('news'));
        var {title , content, linkurl,category ,classify} = this.detail;
        
        return {
            title: `${title}_${tdk.title}·${tdk.webName}`,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: content.replace(/\<((?:.|\n)+?)\>/ig, '').replace(/\s/g, '').slice(0, 100),
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: `${title},${content},${linkurl},${category},${classify}`,
                }
            ],
        }
    },

    async asyncData(context) {
    
        // 获取详情
        let detail = await appNode.ssrReq
                .call(context, `${context.store.state.api.lobalUrl}/college/news/detail`, {
                    guid: context.params.guid,
                })
                .then((data) => data);
      
        return {
            detail,
        };
    },

    data() {
        return {
           
        };
    },
    methods: {
        
    },
    mounted() {
        
    },
};
</script>

<style lang="scss" scoped>
.page-news-detail {
}

.context {
    box-shadow: 0px 9px 27px 0px #e8eaef;
    border: solid 3px #ffffff;
    background-image: linear-gradient(180deg, #f5f7f9 0%, #fefefe 100%);
    padding: 21px 15px;
    margin: 26px 0;
    min-height: 600px;

    .title {
        font-size: 24px;
        color: #1b1b1b;
        font-weight: bold;
        text-align: center;
        margin-bottom: 1em;
    }

    .addtime {
        font-size: 18px;
        color: #1b1b1b;
        text-align: center;
        margin-bottom: 1em;
    }

    .link {
        display: block;
        text-align: center;
        margin-top: 40px;
    }
}
</style>